import { Stack } from '@mui/material';
import { useQuery } from '@tanstack/react-query';

import { Text, api, getQueryProps, isDefined, isTruthy } from 'common';

interface FlowTemplateCardBrandingProps {
  organizationId: string;
}

export function FlowTemplateCardBranding(props: FlowTemplateCardBrandingProps) {
  const { organizationId } = props;

  const { data: theme } = useQuery({
    ...getQueryProps(api.client.PracticeTheme, 'findLogoByQuery', { organizationId }),
    enabled: isTruthy(organizationId),
    retry: 0,
  });

  if (!isDefined(theme?.previsitLogoUrl)) {
    return null;
  }

  return (
    <Stack gap={1}>
      <Text variant="subtitle2" color="text.secondary" bold>
        Created by
      </Text>
      <Stack direction="row" sx={{ width: '50%' }}>
        <img
          src={theme.previsitLogoUrl}
          alt=""
          style={{
            maxWidth: '100%',
            maxHeight: '32px',
          }}
        />
      </Stack>
    </Stack>
  );
}
